import * as React from 'react'

import {
  type Colors,
  type FontsSizes,
  type FontsWeights,
  Text,
  type WhiteSpace,
} from '@factorialco/deprecated-design-system'

import { useMemo } from 'modules/core/hooks/useMemo'
import { minutesToText } from 'modules/core/lib/duration'

interface Props {
  value: number
  alwaysRemainder?: boolean
  withPlusSign?: boolean
  size?: FontsSizes
  weight?: FontsWeights
  color?: Colors
  caps?: boolean
  whiteSpace?: WhiteSpace
  useColumnSeparator?: boolean
}

const MinutesToText = ({
  value,
  alwaysRemainder = false,
  withPlusSign = false,
  size = '300',
  weight = 'normal',
  color = 'grey800',
  caps = false,
  whiteSpace = 'normal',
  useColumnSeparator = false,
}: Props) => {
  const text = useMemo(
    () => minutesToText(value, alwaysRemainder, withPlusSign, false, useColumnSeparator),
    [value, alwaysRemainder, withPlusSign, useColumnSeparator]
  )

  return (
    <Text color={color} size={size} weight={weight} caps={caps} whiteSpace={whiteSpace}>
      {text}
    </Text>
  )
}

export default MinutesToText
